/* This file exists to help translate AuthNPolicyConditionsType values
  to the expected types for the ConditionsSection.vue component.
*/

// Dependencies
import { ExpressionType } from 'client/Security/data/Condition';

// Type classes
import ConditionDevice from 'client/Security/data/ConditionDevice';
import ConditionDeviceEncrypted from 'client/Security/data/ConditionDeviceEncrypted';
import ConditionIpList from 'client/Security/data/ConditionIpList';
import ConditionLocations from 'client/Security/data/ConditionLocations';

const ConditionTypes = {
  [ExpressionType.device]: data => new ConditionDevice(data),
  [ExpressionType.deviceEncrypted]: data => new ConditionDeviceEncrypted(data),
  [ExpressionType.ipAddresses]: data => new ConditionIpList(data),
  [ExpressionType.locations]: data => new ConditionLocations(data),
};

export const ConditionTypeSerializer = {
  ipAddressIn: ConditionIpList.fromApi,
  deviceManaged: ConditionDevice.fromApi,
  deviceEncrypted: ConditionDeviceEncrypted.fromApi,
  locationIn: ConditionLocations.fromApi,
};

export default ConditionTypes;
